import * as t from 'io-ts';

export const AircraftDynamicType = t.interface({
    registration: t.string,
    type: t.string
});

export type Aircraft = t.TypeOf<typeof AircraftDynamicType>;
